<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.title || $t('bill.text_291') }}</div>
    <div slot="body">
      <!-- 新建表单 -->
      <a-form :form="form.fc" v-bind="formLayout">
        <a-form-item>
          <span slot="label">
            {{$t('bill.text_292')}}&nbsp;
            <a-popover>
              <template slot="content">
                <img src="../assets/dimension-tooltip.png" />
              </template>
              <template v-slot:default>
                <icon type="question" />
              </template>
            </a-popover>
          </span>
          <a-input v-decorator="decorators.name" :placeholder="$t('bill.text_293')" />
        </a-form-item>
        <a-form-item :label="$t('bill.text_294')">
          <div class="tag-wrapper" v-decorator="decorators.tags">
            <div class="tag-list" v-if="selectedTagsList.length">
              <template v-for="(item, index) in selectedTagsList">
                <span
                  class="tag mb-1 d-inline-block"
                  :title="item.title"
                  :key="index"
                  :style="{ backgroundColor: item.backgroundColor, color: item.color, borderColor: item.color }">
                  <div class="d-flex align-items-center">
                    <span class="flex-fill text-truncate">{{ item.title }}</span>
                    <a-icon class="ml-1 remove-tag flex-grow-0 flex-shrink-0" type="close" @click.stop="removeTag(item)" />
                  </div>
                </span>
              </template>
            </div>
            <div style="color:rgba(0,0,0,0.45);padding:0 8px;font-size:12px">
              <span>{{$t('cloudenv.text_272')}}{{selectedTagsList.length || 0}}</span>
              <a-button v-if="selectedTagsList.length" type="link" @click="clearTags">{{$t('common_97')}}</a-button>
            </div>
          </div>
        </a-form-item>
      </a-form>
      <!-- 维度项列表 -->
      <page-list
      ref="dimensionTable"
      row-id="id"
      :list="list"
      :columns="columns"
      :showSync="false"
      :showCheckbox="true"
      :group-actions="groupActions"
      :show-group-actions="false"
      @change-selected="checkChange" />
    </div>
    <div slot="footer">
      <a-button v-bind="okButtonProps" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import _ from 'lodash'
import i18n from '@/locales'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter, getBrandFilter, getResourceTypeFilter } from '@/utils/common/tableFilter'
import { getBrandTableColumn } from '@/utils/common/tableColumn'
import { getBillResourceTypeLabel } from '@Bill/utils'
import DimensionMixin from '../mixins/dimension'

const Columns = {
  bill: [
    {
      field: 'usage_type',
      title: i18n.t('bill.usage_type'),
    },
    getBrandTableColumn(),
    {
      field: 'resource_type',
      title: i18n.t('bill.text_73'),
      formatter: ({ row }) => {
        return getBillResourceTypeLabel(row.resource_type)
      },
    },
    {
      field: 'description',
      title: i18n.t('table.title.desc'),
    },
  ],
  resource_type: [
    {
      field: 'resource_type',
      title: i18n.t('bill.text_73'),
      formatter: ({ row }) => {
        return getBillResourceTypeLabel(row.resource_type)
      },
    },
    getBrandTableColumn(),
  ],
  domain: [
    {
      field: 'name',
      title: i18n.t('bill.text_88'),
    },
    {
      field: 'description',
      title: i18n.t('table.title.desc'),
    },
  ],
  project: [
    {
      field: 'name',
      title: i18n.t('bill.text_88'),
    },
    {
      field: 'project_domain',
      title: i18n.t('bill.text_76'),
    },
    {
      field: 'description',
      title: i18n.t('table.title.desc'),
    },
  ],
}
export default {
  name: 'DimensionItemSelectDialog',
  components: {
  },
  filters: {

  },
  mixins: [DialogMixin, WindowsMixin, ListMixin, DimensionMixin],
  props: {
    params: Object,
  },
  data () {
    let resource = 'billsdimensionsanalysis'
    const dimension_type = _.get(this.params, 'dimension_type')
    if (dimension_type === 'domain') {
      resource = 'domains'
    } else if (dimension_type === 'project') {
      resource = 'projects'
    }
    const initialName = this.params.dimension_name || ''
    const filterOptions = this.getFilterOptions(dimension_type)
    return {
      loading: false,
      initDimensionData: this.params.defaultDimensionData || null,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        name: [
          'name',
          {
            initialValue: initialName,
            rules: [{ required: true, message: this.$t('bill.text_293') }],
          },
        ],
        tags: [
          'tags',
          {
            rules: [
              { required: true, message: this.$t('bill.text_295'), validator: this.tagsValidator },
            ],
          },
        ],
      },
      formLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      selectedTagsList: [],
      list: this.$list.createList(this, {
        apiVersion: 'v1',
        resource,
        getParams: { details: true },
        fetchDataCb: this.fetchDataCb,
        limit: 10,
        filterOptions,
      }),
      columns: Columns[dimension_type],
      groupActions: [
        {
          label: '',
          permission: 'billsdimensions_create',
          action: () => {
          },
        },
      ],
      allSelected: {},
    }
  },
  created () {
    try {
      const { excludeDimensionList = [], dimension_type } = this.params
      if (excludeDimensionList.length > 0) {
        let excludeList = []
        if (dimension_type === 'bill') {
          excludeDimensionList.map(item => {
            excludeList = excludeList.concat(item[this.dimensionParamsMap[dimension_type].id])
          })
          this.list.getParams.exclude_ids = excludeList
        } else if (dimension_type === 'resource_type') {
          excludeDimensionList.map(item => {
            item[this.dimensionParamsMap[dimension_type].id].map(item2 => {
              excludeList.push(`${item2.brand},${item2.resource_type}`)
            })
          })
          this.list.getParams.resource_type_filter = excludeList
        } else if (dimension_type === 'domain') {
          excludeDimensionList.map(item => {
            item[this.dimensionParamsMap[dimension_type].name].map(item2 => {
              item2.domain_id && excludeList.push(item2.domain_id)
            })
          })
          this.list.getParams.filter = `id.notin(${excludeList.join(',')})`
        } else if (dimension_type === 'project') {
          excludeDimensionList.map(item => {
            item[this.dimensionParamsMap[dimension_type].name].map(item2 => {
              item2.project_id && excludeList.push(item2.project_id)
              item2.tenant_id && excludeList.push(item2.tenant_id)
            })
          })
          this.list.getParams.filter = `id.notin(${excludeList})`
        }
      }
      if (dimension_type === 'resource_type') {
        this.list.getParams.dimension_type = 'resource_type'
      }
    } catch (err) {
      throw err
    }

    this.list.fetchData()
  },
  methods: {
    fetchDataCb () {
      // 当为修改时，添加默认选项
      if (this.initDimensionData) {
        this.addDefaultDimensionList()
      }
      // this.changeSelectedStatus()
      // 更新列表信息后将选中的行反选到列表中
      const $grid = this.$refs.dimensionTable.$refs.table.$refs.grid
      $grid.clearCheckboxRow()
      // 用获取到的列表更换selectedTagsList中不规范的数据
      if (this.params.dimension_type === 'resource_type') {
        this.selectedTagsList = this.getSelectedTagsListUpdatedFromList(this.selectedTagsList, 'resource_type')
      }
      $grid.setCheckboxRow(this.selectedTagsList, true)
      this.list.clearSelected()
      this.list.changeSelected(this.selectedTagsList)
    },
    getFilterOptions (dimension_type) {
      const filterOptions = {
        name: getNameFilter({ label: dimension_type === 'bill' ? this.$t('bill.usage_type') : this.$t('table.title.name') }),
        description: {
          label: this.$t('table.title.desc'),
          filter: true,
          formatter: val => {
            return `description.contains('${val}')`
          },
        },
        brand: getBrandFilter(),
        resource_type: getResourceTypeFilter(),
      }
      if (dimension_type === 'domain' || dimension_type === 'project') {
        delete filterOptions.brand
        delete filterOptions.resource_type
      } else if (dimension_type === 'resource_type') {
        delete filterOptions.name
        delete filterOptions.description
      }
      return filterOptions
    },
    getSelectedTagsListUpdatedFromList (selectedTagsList, dimension_type) {
      const selectedTagsListNew = []
      const { data } = this.list
      const dataKeys = Object.keys(data)
      selectedTagsList.map(item => {
        let selectedItem = item
        dataKeys.map(item2 => {
          if (item.id === `${data[item2].data.resource_type}-${data[item2].data.brand}`) {
            selectedItem = Object.assign({}, data[item2].data, { title: this.dimensionTag(data[item2].data, dimension_type) })
          }
        })
        selectedTagsListNew.push(selectedItem)
      })
      return selectedTagsListNew
    },
    removeTag (item) {
      this.changeSelectedStatus(item.id)
    },
    checkChange () {
      this.changeSelectedStatus()
    },
    changeSelectedStatus (delId = '') {
      // 去除未选的，添加新选的
      // 当前列表
      const currentIds = Object.keys(this.list.data)
      const { selected, data } = this.list
      let allSelected = Object.assign(this.allSelected)
      if (this.params.dimension_type === 'resource_type') {
        allSelected = {}
        for (const key in this.allSelected) {
          const { brand = '', resource_type = '' } = this.allSelected[key].data
          if (key === `${resource_type}-${brand}`) {
            const xx = currentIds.filter(id => {
              return key === `${data[id].data.resource_type}-${data[id].data.brand}`
            })
            if (xx.length) {
              allSelected[xx[0]] = data[xx[0]]
            } else {
              allSelected[key] = this.allSelected[key]
            }
          } else {
            allSelected[key] = this.allSelected[key]
          }
        }
      }
      // 选中列表
      currentIds.map(id => {
        if (selected.includes(id)) {
          allSelected[id] = data[id]
        } else {
          delete allSelected[id]
        }
      })
      // removeTag时使用
      if (delId && allSelected[delId]) {
        delete allSelected[delId]
      }
      const ids = Object.keys(allSelected)
      const selectedTagsList = ids.map(id => {
        if (this.params.dimension_type === 'domain' && !allSelected[id].data.name) {
          const domains = this.params.domainList.filter(item => {
            return item.id === id
          })
          if (domains[0]) {
            return Object.assign(domains[0], { title: this.dimensionTag(domains[0], this.params.dimension_type) })
          }
        }
        if (this.params.dimension_type === 'project' && !allSelected[id].data.name) {
          const projects = this.params.projectList.filter(item => {
            return item.id === id
          })
          if (projects[0]) {
            return Object.assign(projects[0], { title: this.dimensionTag(projects[0], this.params.dimension_type) })
          }
        }
        return Object.assign(allSelected[id].data, { title: this.dimensionTag(allSelected[id].data, this.params.dimension_type) })
      })
      this.allSelected = allSelected
      // 用于展示的已选列表
      this.selectedTagsList = selectedTagsList
      this.form.fc.setFieldsValue({
        tags: selectedTagsList,
      })
      if (delId) {
        this.fetchDataCb()
      }
    },
    addDefaultDimensionList () {
      // 生成allSelected
      const allSelected = {}
      // 生成selectTagsList
      const { dimension_type } = this.initDimensionData
      let dimensionListName = ''
      if (dimension_type === 'bill' || dimension_type === 'resource_type') {
        dimensionListName = 'dimensions_analysis'
      } else if (dimension_type === 'domain') {
        dimensionListName = 'dimension_domains'
      } else if (dimension_type === 'project') {
        dimensionListName = 'dimension_projects'
      }
      if (!(dimensionListName && this.initDimensionData[dimensionListName])) return false
      let selectedTagsList = this.initDimensionData[dimensionListName].map(item => {
        const id = item.id || item.domain_id || item.project_id || item.tenant_id || `${item.resource_type}-${item.brand}`
        id && (allSelected[id] = {
          id,
          data: Object.assign({}, { id }, item),
        })
        if (dimension_type === 'domain') {
          const domains = (this.params.domainList || []).filter(domain => {
            return domain.id === item.domain_id
          })
          if (domains[0]) {
            return Object.assign({}, { id }, item, { title: this.dimensionTag(domains[0], dimension_type) })
          }
        }
        if (dimension_type === 'project') {
          const projects = (this.params.projectList || []).filter(project => {
            return (project.id === item.project_id || project.id === item.tenant_id)
          })
          if (projects[0]) {
            return Object.assign({}, { id }, item, { title: this.dimensionTag(projects[0], dimension_type) })
          }
        }
        return Object.assign({}, { id }, item, { title: this.dimensionTag(item, dimension_type) })
      })

      // resource_type没存ID，需从列表中获取
      if (dimension_type === 'resource_type') {
        selectedTagsList = this.getSelectedTagsListUpdatedFromList(selectedTagsList, dimension_type)
      }
      this.selectedTagsList = selectedTagsList
      this.form.fc.setFieldsValue({
        tags: selectedTagsList,
      })
      this.allSelected = allSelected
      this.initDimensionData = {}
    },
    tagsValidator (rule, val, callback) {
      if (!this.selectedTagsList || !this.selectedTagsList.length) {
        // eslint-disable-next-line
        callback(false)
      }
      callback()
    },
    clearTags () {
      this.selectedTagsList = []
      this.form.fc.setFieldsValue({
        tags: [],
      })
      this.allSelected = {}
      this.initDimensionData = {}
      this.fetchDataCb()
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        // 针对修改
        const { defaultDimensionData = { joint_id: '' } } = this.params
        values.id = defaultDimensionData.joint_id
        this.params.complate && this.params.complate(this, values)
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="less" scoped>
.tag-wrapper{
  min-height: 32px;
  border: 1px solid #ddd;
}
.tag-list {
  padding: 3px 8px;
}
.tag {
  max-width: 100%;
  line-height: 20px;
  margin: 4px 10px 4px 0;
  padding: 0 6px 0 4px;
  font-size: 12px;
  border-style: solid;
  border-width: 1px;
}
</style>
